
import React from 'react';
import { Button } from "@/components/ui/button";
import { Loader2 } from 'lucide-react';

interface WizardActionsProps {
  currentStep: number;
  isLastStep: boolean;
  isSubmitting: boolean;
  isFormValid: boolean;
  onBack: () => void;
  onNext: () => void;
  onSubmit: () => Promise<void>;
}

export const WizardActions = ({ 
  currentStep, 
  isLastStep, 
  isSubmitting, 
  isFormValid,
  onBack, 
  onNext,
  onSubmit
}: WizardActionsProps) => {
  return (
    <div className="flex justify-between mt-6">
      <Button
        variant="outline"
        onClick={onBack}
        disabled={currentStep === 0 || isSubmitting}
      >
        Previous
      </Button>
      
      {isLastStep ? (
        <Button 
          onClick={onSubmit}
          disabled={isSubmitting || !isFormValid}
        >
          {isSubmitting ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Creating Provider...
            </>
          ) : (
            'Create Provider'
          )}
        </Button>
      ) : (
        <Button 
          onClick={onNext}
          disabled={currentStep === 1 ? false : (isSubmitting || !isFormValid)} // Make user assignment always allow next
        >
          Next Step
        </Button>
      )}
    </div>
  );
};
